import { ProcessOfferSubgroupDishesDialogFormModel } from '@/views/processes/offerSubgroup/components/dialog/model/ProcessOfferSubgroupDishesDialogForm.model.ts';

export type ProcessOfferDishesTranslation = {
  button: {
    cancel: string;
    submit: string;
  };
  form: Record<keyof ProcessOfferSubgroupDishesDialogFormModel, string>;
  picker: {
    action: {
      addSelected: string;
      clear: string;
      removeSelected: string;
      selectAll: string;
    };
    available: string;
    availableEmpty: string;
    collapsedSummary: {
      dietaryPreferences: string;
      guestCount: string;
      tags: string;
    };
    emptySelected: string;
    eventTypeNarrowing: {
      chipsLabel: string;
      disable: string;
      enable: string;
      off: string;
      on: string;
      onUnnamed: string;
    };
    filters: {
      collapse: string;
      expand: string;
      show: string;
    };
    guestCountLabel: string;
    guestCountTooltip: string;
    loaded: string;
    onlyAvailableInTerm: string;
    onlyAvailableInTermTooltip: string;
    outOfTermHidden: string;
    selected: string;
    selectedCount: string;
    selectedSummary: string;
    totalPrice: string;
  };
  selectDepartmentFirst: string;
};

export const processOfferDishesTranslation: ProcessOfferDishesTranslation = {
  button: {
    cancel: 'Anuluj',
    submit: 'Zapisz',
  },
  form: {
    department: 'Dział',
    dietaryPreferences: 'Preferencje',
    fullTextSearchInput: 'Wyszukaj',
    tags: 'Tagi',
    type: 'Typ',
  },
  picker: {
    action: {
      addSelected: 'Dodaj zaznaczone',
      clear: 'Wyczyść',
      removeSelected: 'Cofnij zaznaczone',
      selectAll: 'Zaznacz wszystkie',
    },
    available: 'Dostępne',
    availableEmpty: 'Brak dań pasujących do filtrów.',
    collapsedSummary: {
      dietaryPreferences: '{{count}} pref.',
      guestCount: '{{count}} gości',
      tags: '{{count}} tag.',
    },
    emptySelected: 'Nic nie wybrano. Użyj „+" przy daniu albo zaznacz wiele i wciśnij »',
    eventTypeNarrowing: {
      chipsLabel: 'Tagi typu:',
      disable: 'Pokaż wszystkie dania',
      enable: 'Zawęź ponownie',
      off: 'Zawężenie po typie wydarzenia wyłączone — widzisz pełną listę dań.',
      on: 'Lista zawężona przez typ wydarzenia „{{eventType}}".',
      onUnnamed: 'Lista zawężona przez typ wydarzenia.',
    },
    filters: {
      collapse: 'Zwiń filtry i tagi',
      expand: 'Pokaż filtry i tagi',
      show: 'Kliknij aby pokazać filtry',
    },
    guestCountLabel: 'Liczba gości',
    guestCountTooltip:
      'Liczba gości na wydarzeniu — równocześnie domyślna ilość porcji dla nowo dodawanych dań',
    loaded: 'Wczytano {{visible}} z {{total}} dań…',
    onlyAvailableInTerm: 'Tylko dostępne w terminie',
    onlyAvailableInTermTooltip:
      'Ukryj dania, których sezonowość lub cennik nie obejmują daty wydarzenia. Domyślnie widać wszystkie — te niepasujące są tylko oznaczone ikoną.',
    outOfTermHidden: 'ukryto {{count}}',
    selected: 'Wybrane',
    selectedCount: '{{checked}}/{{total}} zaznaczone',
    selectedSummary: '{{count}} wybranych',
    totalPrice: '{{price}} zł',
  },
  selectDepartmentFirst: 'Wybierz dział by zobaczyć listę portaw',
};
